import {
  isValid as isDateValid,
  intervalToDuration as dateIntervalToDuration,
  isAfter as isDateAfter,
} from "date-fns";
import get from "lodash-es/get";
import isString from "lodash-es/isString";
import isArray from "lodash-es/isArray";
import { boolean } from "boolean";
import syncProLogo from "@/assets/images/logos/support_sync_logo.svg";
import syncProLogoCropped from "@/assets/images/logos/support_sync_logo_cropped.svg";
import syncProLogoRaw from "@/assets/images/logos/support_sync_logo.svg?url";
import type {
  TicketActivityResource,
  TicketActivityType,
} from "~/types/entities/ticket";

export const inDevelopment = computed(
  () =>
    import.meta.client && useRuntimeConfig().public.node_env === "development",
);

export const isLocalMachine = computed(() =>
  boolean(useRuntimeConfig().public.onLocalMachine),
);

export const inProduction = computed(
  () =>
    import.meta.client &&
    useRuntimeConfig().public.node_env === "production" &&
    !useRuntimeConfig().public.inStaging,
);

export const inStaging = computed(
  () =>
    import.meta.client &&
    ((inProduction.value && useRuntimeConfig().public.inStaging) ||
      inDevelopment.value),
);

export const textSeperator = (val?: string | null) => {
  return val && isString(val) ? " " : "";
};

export const buildFullName = (...names: (string | null | undefined)[]) => {
  let fullName = "";

  names.forEach((name) => {
    if (isString(name)) {
      fullName = `${fullName}${textSeperator(name)}${name}`;
    }
  });

  return fullName;
};

export const countDown = (startDate: string | Date, endDate: string | Date) => {
  const start = isString(startDate) ? new Date(startDate) : startDate;
  const end = isString(endDate) ? new Date(endDate) : endDate;

  try {
    if (isDateValid(start) && isDateValid(end) && isDateAfter(end, start)) {
      const intervalResp = dateIntervalToDuration({
        start,
        end,
      });

      return intervalResp;
    }
  } catch {
    //
  }

  return undefined;
};

export { default as ucwords } from "locutus/php/strings/ucwords";

export const mergeActivityResourceWithLinks = (
  activity: TicketActivityType,
  resources: TicketActivityResource,
) => {
  if (activity && activity.resource_links && isArray(activity.resource_links)) {
    activity.resource_links.forEach((key) => {
      const obj = resources[key];
      if (!obj) {
        return;
      }

      const keySplits = key.split(":");
      const type = keySplits[0].substring(1);

      if (!type) {
        return;
      }

      const url = get(obj, "url", `#${type}/${obj.id}`);
      const prependAt = type === "file" ? false : true;

      const linkReplacement = `<a class="text-primary-darken-1" href="${url}" target="_blank">${prependAt ? `@` : ""}${obj.name}</a>`;
      activity.message = activity.message.replaceAll(key, linkReplacement);
    });
  }

  return activity;
};

export const appLogo = computed(() => {
  const publicRuntimeConfig = useRuntimeConfig().public;
  return (publicRuntimeConfig.appLogo as string) || syncProLogo;
});
export const appLogoCropped = computed(() => {
  const publicRuntimeConfig = useRuntimeConfig().public;
  console.log("logo", publicRuntimeConfig.appLogoCropped);
  return publicRuntimeConfig.appLogoCropped || syncProLogoCropped;
});

export const appLogoCroppedRaw = computed(() => {
  const publicRuntimeConfig = useRuntimeConfig().public;
  return publicRuntimeConfig.appLogoCropped || syncProLogoRaw;
});
